// extracted by mini-css-extract-plugin
module.exports = {"main-component":"executePopupBackground_main-component__1zqKJ"};